import axios from "axios";
import { ENDPOINT } from "@/config";
import { ascendingSort } from "@/utils";
import * as queryString from "query-string";

// Default state
const defaultState = () => {
  return {
    error: null,
    plans: [],
    availablePlans: [],
    allPlans: [],
    isLoadingPlans: false,
    isLoadingAllPlans: false,
  };
};

// State object
const state = defaultState();

// Getter functions
const getters = {
  getPlans(state) {
    return state.plans;
  },
  getAllPlans(state) {
    return state.allPlans;
  },
  getAllTherapistClientPlans(state) {
    return state.allPlans.filter((plan) => plan.programme_type === "therapist");
  },
  getAvailablePlans(state) {
    return state.availablePlans;
  },
};

// Actions
const actions = {
  async getAllPlansAction({ commit }) {
    commit("SET_ALL_PLANS_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .get(ENDPOINT.allPlans)
        .then((response) => {
          commit("SET_ALL_PLANS_IS_LOADING", false);
          commit("SET_ALL_PLANS", response.data);

          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("SET_ALL_PLANS_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  async getPlansAction({ commit }, payload) {
    commit("SET_PLANS_IS_LOADING", true);

    const query = queryString.stringify(payload);

    return new Promise((resolve, reject) => {
      axios
        .get(`${ENDPOINT.plans}?${query}`)
        .then((response) => {
          commit("SET_PLANS_IS_LOADING", false);
          commit("SET_PLANS", response.data);

          const availablePlans = response.data
            .filter((plan) => plan.active)
            .sort((a, b) =>
              ascendingSort(Number(a.price.amount), Number(b.price.amount))
            );

          commit("SET_AVAILABLE_PLANS", availablePlans);
          resolve(availablePlans);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("SET_PLANS_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};

// Mutations
const mutations = {
  SET_ALL_PLANS_IS_LOADING(state, isLoading) {
    state.isLoadingAllPlans = isLoading;
  },
  SET_ALL_PLANS(state, plans) {
    state.allPlans = plans;
  },
  SET_AVAILABLE_PLANS(state, plans) {
    state.availablePlans = plans;
  },
  SET_PLANS_IS_LOADING(state, isLoading) {
    state.isLoadingPlans = isLoading;
  },
  SET_PLANS(state, plans) {
    state.plans = plans;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  name: "PlanModule",
  dynamic: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
